import React, { useState, useRef } from 'react';
import SessionFun from './functions/sessionFun';
import { Link } from 'react-router-dom';
import { Modal, Form } from 'react-bootstrap';
import { getUserInfo } from './functions/userInfo';
import close from '../Asset/close.svg';
import { environment } from './functions/environment';

function asset_upload() {
    let userObj = getUserInfo();
    let [sessOut, setSessOut] = useState(false);
    let [apiMsg, setApiMsg] = useState({
        msg: "",
        status: false,
        link: ""
    });
    function closeModal() {
        setApiMsg({ msg: "", status: false, link: "" });
    }
    let [file, setFile] = useState(null);
    const filRef = useRef(null);
    let [fileMsg, setFileMsg] = useState("");



    function getSelectedFile(e) {
        setFileMsg("");
        let nameArr = (e.target.files[0].name).split(".");
        if (nameArr.length == 2 && nameArr[1] == "xlsx" && nameArr[0] != "") {
            setFile(e.target.files[0]);
        }
        else {
            setFile(null);
            filRef.current.value = "";
            setFileMsg("Only Excel file allowed.");
        }
    }
    function uploadFile() {
        if (file) {
            let formData = new FormData();
            formData.append("file", file);

            fetch(environment.baseUrl + "assetUpload", {
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + userObj.token,
                },
                body: formData
            }).then((result) => {
                result.json().then((res) => {
                    if (result.status == 200) {
                        setFile(null);
                        filRef.current.value = "";
                    }
                    else if (res.code == 401) {
                        setSessOut(true);
                    }
                    setApiMsg({
                        msg: res.message,
                        status: true,
                        link: res.data ? res.data : null
                        // link: res.downloadLink ? res.downloadLink : null
                    })
                    // console.log("res", res);
                    // var blob = base64toBlob(res.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    // downloadBlob(blob, 'converted_excel_file.xlsx');
                })
            });
        }
        else {
            setFileMsg("Please select file first");
        }
    }
    function triggerFun(){
        var blob = base64toBlob(apiMsg.link, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        downloadBlob(blob, 'Failed_Report.xlsx');
    }
    function base64toBlob(base64Data, contentType) {
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

    function downloadBlob(blob, fileName) {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }


    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <h4 className='main-heading'>SFDC Asset Upload</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; SFDC Asset Upload</p>

            <div className="row card-box-block mt-3">
                <div className="row">
                    <Form.Group className="mb-3" >
                        <Form.Control
                            type="file"
                            name="file"
                            id="file"
                            ref={filRef}
                            onChange={getSelectedFile}
                            accept=".xlsx,.csv"
                        />
                    </Form.Group>
                    <small><b>Note: Please upload SFDC Asset in .xlsx format</b></small>
                    <small className='red'>{fileMsg}</small>
                </div>
                <div className="row text-center mt-3">
                    <div className="col-sm-12">
                        <button className="btn btn-light lo-btn confirm-btn float-end" onClick={uploadFile}>
                            Upload
                        </button>
                    </div>
                </div>
            </div>
            <Modal show={apiMsg.status} onHide={closeModal} centered backdrop="static" size="sm">
                <Modal.Header>
                    <Modal.Title>Message</Modal.Title>
                    <button onClick={closeModal} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className='text-center logout-box'>
                    <p className='mb-0'><b>{apiMsg.msg}</b></p>
                    {
                        apiMsg.link ?
                            <button className='btn btn-link' onClick={triggerFun}>Failed Report</button>
                            // <a href={apiMsg.link} target="_blank">Failed Report</a>
                            : null
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default asset_upload
